import { FormattedMessage } from 'react-intl';

import { StartRentalDialogScreenshot } from './StartRentalDialogScreenshot';
import { StartRentalButtonScreenshot } from './StartRentalButtonScreenshot';

export const ExternalRental = () => (
    <div className='max-width-800'>
        <p>
            <FormattedMessage id='intl-msg:rental-web.serviceInfo.whatsNew.step1' />
        </p>
        <StartRentalButtonScreenshot />
        <p>
            <FormattedMessage id='intl-msg:rental-web.serviceInfo.whatsNew.step2' />
        </p>
        <StartRentalDialogScreenshot />
        <p>
            <FormattedMessage id='intl-msg:rental-web.serviceInfo.whatsNew.step3' />
        </p>
    </div>
);
